import {useState} from "react";

const useCount = (initValue = 1, maxCount = 999) => {
  const [count, setCount] = useState(initValue);
  
  const addCount = () => {
    if (count >= maxCount) return;
    setCount(count + 1);
  };
  
  const subCount = () => {
    let res = count - 1;
    if (res <= 0) return;
    setCount(res);
  };
  
  return [count, addCount, subCount];
};

export {useCount};
